import { Component, forwardRef, OnInit } from '@angular/core'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { SelectableDealOption } from 'modules/deals/utilities/deal-types'
import { ConfigurationOptionSelectAdvancedComponent } from '../configuration-option-select-advanced/configuration-option-select-advanced.component'

@Component({
    selector: 'mg-configuration-option-select-advanced-interior-triple-choice',
    templateUrl: './configuration-option-select-advanced-interior-triple-choice.component.html',
    styleUrls: ['./configuration-option-select-advanced-interior-triple-choice.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedInteriorTripleChoiceComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedInteriorTripleChoiceComponent),
            multi: true,
        },
    ],
})
export class ConfigurationOptionSelectAdvancedInteriorTripleChoiceComponent extends ConfigurationOptionSelectAdvancedComponent {
    getImageSrc(optionLabel: string) {
        const option = this.configurationOption as SelectableDealOption
        const model = option.selectedValue.labelId.includes('model_s') ? 's' : 'x'

        let color

        if (optionLabel.includes('Black') && optionLabel.includes('White')) {
            color = 'white'
        } else if (optionLabel.includes('Black')) {
            color = 'black'
        } else if (optionLabel.includes('Cream')) {
            color = 'cream'
        }

        if (optionLabel.includes('Fiber')) {
            color += '-fiber'
        }

        return `assets/images/model-${model}-interior/model-${model}-interior-${color}.jpg`
    }
}
